{{custom-wizard-tag-chooser
  tags=this.field.value
  class=this.fieldClass
  tabindex=this.field.tabindex
  tagGroups=this.field.tag_groups
  everyTag=true
  options=(hash maximum=this.field.limit allowAny=this.field.can_create_tag)
}}